import React from 'react';
import { Link } from 'react-router-dom';
import '../OtherVideos/other.css';

function CharlieChaplin() {
  return (
    <div className="charlie-page">
      <h1 className="charlie-title">🎩 Chaplin Film Scenes & PASSION Themes</h1>

      <div className="charlie-table-container">
        <table className="charlie-table">
          <thead>
            <tr>
              <th>Clip / Film Scene</th>
              <th>Theme(s)</th>
              <th>Modern Interpretation</th>
              <th>View Clip</th>
            </tr>
          </thead>
          <tbody>
            {chaplinData.map((item, index) => (
              <tr key={index}>
                <td>{item.scene}</td>
                <td>{item.themes}</td>
                <td>{item.interpretation}</td>
                <td>
                  <iframe
                    className="charlie-iframe"
                    src={item.video}
                    title={item.scene}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/zones" className="back-button">
          ⬅ Back to Museum Realms
        </Link>
      </div>
    </div>
  );
}

const chaplinData = [
  {
    scene: "The Kid (1921) – Pancake/Breakfast Scene",
    themes: "Nurturing, Peace, Love, Protector",
    interpretation: "Reminds of kids helping family—promotes care & bonding",
    video: "https://www.youtube-nocookie.com/embed/V_M3Jw3zoPY?rel=0&modestbranding=1"
  },
  {
    scene: "The Gold Rush – Bread Roll Dance",
    themes: "Acting, Innovating, Unity, Joy",
    interpretation: "Fun creativity using bread as dance props—celebrates imagination",
    video: "https://www.youtube-nocookie.com/embed/4DLdMa98JdM?rel=0&modestbranding=1"
  },
  {
    scene: "The Great Dictator – Final Speech",
    themes: "Peace, Unity, Love, Respect, Trust, Scoping, Positive Utility",
    interpretation: "Encourages kindness and humanity—timeless message for social harmony",
    video: "https://www.youtube-nocookie.com/embed/J7GY1Xg6X20?rel=0&modestbranding=1"
  },
  {
    scene: "Modern Times – Roller Skate Scene",
    themes: "Acting, Trust, Tempting, Playful Danger",
    interpretation: "Highlights innocence and playful courage—balance thrill and safety",
    video: "https://www.youtube-nocookie.com/embed/kPcEFHA3X0c?rel=0&modestbranding=1"
  }
];

export default CharlieChaplin;
